import _ from 'lodash';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { selectActiveCampaignList } from 'app/campaign/features/campaign.selectors';
import { selectCampaign } from 'app/campaign/features/campaign.actions';
import { CAMPAIGN_TYPE } from '../../virtual-event.enums';
import { selectVirtualEventData } from '../../features/data/data.selectors';
import { combineAll, filter, first, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { MdbSelectComponent } from 'mdb-angular-ui-kit/select';
import { UntypedFormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-campaign-list',
  templateUrl: './campaign-list.component.html',
  styleUrls: ['./campaign-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignListComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input() theme = 'dark'


  public data$: any = this.store.pipe(select(selectVirtualEventData));
  public list$: any = this.store.pipe(
    select(selectActiveCampaignList),
    map(list => {
      return _.filter(list, campaign => {
        switch(campaign.type) {
          case CAMPAIGN_TYPE.AUCTION:
          case CAMPAIGN_TYPE.DONATE:
          case CAMPAIGN_TYPE.LAST_HERO:
              return true;
        }
        return false;
      });
    }),
    map(list => {
      return list.length < 1 ? false: list;
    })
  );
  public selected: UntypedFormControl = new UntypedFormControl(null);
  public selectClass:string = ''

  constructor(
    private store: Store<any>
  ) {}

  ngOnInit(): void {
    of(this.data$, this.list$).pipe(
      combineAll(),
      filter((results: any) => {
        const id = _.get(results[0], 'id', null);
        return !_.isNull(id);
      }),
      filter((results: any) => results[1].length > 0),
      first(),
     takeUntilDestroyed(this.destroyRef)
    ).subscribe(results => {
      const data = results[0];
      const list = results[1];

      const id = _.get(data, 'currentItem.currentCampaign', null);
      const campaign = _.find(list, { id }) || null;

      if(!_.isNull(campaign)) {
        this.onSelect(campaign);
      }
    })
  }

addClass(){
  this.selectClass='opened'
}
removeClass(){
  this.selectClass=''
}

  getCampaignIcon(campaign) {
    switch(campaign.type) {
      case CAMPAIGN_TYPE.AUCTION:
        return '/img/svg/auction.svg';
      case CAMPAIGN_TYPE.DONATE:
        return '/img/svg/donation.svg';
      case CAMPAIGN_TYPE.LAST_HERO:
        return '/img/svg/last-hero.svg';
    }
    return '';
  }

  onClick(event, select: MdbSelectComponent) {
    event.preventDefault();
    event.stopPropagation();
    return select.isExpanded ? select.close(): select.open();
  }

  onSelect(campaign) {
    this.selected.setValue(campaign);
    this.store.dispatch({
      type: selectCampaign.type,
      payload: campaign.id
    });
  }

  getDropdownToggleLabel() {
    return _.isNull(this.selected.value) ? 'Select Campaign': _.get(this.selected.value, 'name', 'Select Campaign');
  }
}
